import axios from 'axios'
import store from '@/store'
import errorHandler from '@/utils/apiErrorHandler'

async function updateRejectedEconomicGroup({economicGroupId, sponsorCnpjId, rejected}) {
    try {
        const result = await axios.put(`${process.env.VUE_APP_ROOT_API}/clients/v1/economicgroup/${economicGroupId}/sponsors/rejection`, {
            rejected,
            cnpjId: sponsorCnpjId

        }, {
            headers: {
                Authorization: `Bearer ${store.state.user.token}`
            }
        })

        return result.data
    } catch(err) {
        console.log(err);
        errorHandler(err.response)
    }
}

export default updateRejectedEconomicGroup